import React from 'react'
import { CallToAction } from 'components/CallToAction'
import { RenderInClient } from 'components/RenderInClient'
import useiCloudReady from '../../hooks/useiCloudReady'
import { prepareData } from 'utils/googleData'

/**
 * A signup CTA that directs to the correct region (EU or US) based on real estate marketing.
 */
export const SignupCTA = (props: {
    text?: string
    className?: string
    type?: string
    width?: string
    event?: any
}): JSX.Element => {
    const {
        enable,
        text = 'Get started - free',
        type = 'primary',
        width,
        event,
        url = 'https://app.icloud-ready.com/register',
        subtitle,
        description,
        cta,
        direction,
        style: className = '',
        gatsbyImage,
        features,
        gatsbyImage2,
    } = prepareData({ props })
    if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    const icloudready = useiCloudReady()

    return (
        <RenderInClient
            placeholder={
                <CallToAction
                    type={type}
                    direction={direction}
                    className={className}
                    width={width}
                    to={url}
                    event={event}
                >
                    {text}
                </CallToAction>
            }
            render={() => (
                <CallToAction
                    type={type}
                    className={className}
                    direction={direction}
                    width={width}
                    to={url}
                    // to={`https://${
                    //     icloudready?.isFeatureEnabled('direct-to-saudi-cloud') ? 'app' : 'app'
                    // }.icloud-ready.com/register`}
                    event={event}
                >
                    {text}
                </CallToAction>
            )}
        />
    )
}
